import { scenes } from "../scenes";
import { Scene, Dialog } from "../models";
import { yang, dareth, toiletPaper, canOfFood } from "@/images";

const confrontation = [
  new Dialog(
    "SONNY YANG: Huzzah! I’ve now retrieved two of my stolen items. Now all I have to do is find my bottle of SANITIZER and I’ll be well - prepared for social quarantine…",
    yang,
    require("@/audio/Pandemic-179-Sonny-1-MP3.mp3")
  ),
  new Dialog(
    "Well well Sonny Yang, I must say I never took you for a burglar",
    dareth,
    require("@/audio/Pandemic-179-Dareth-1-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: Dareth Schamren! You’re a fiend and a scoundrel for assaulting me at the Supermarket!",
    yang,
    require("@/audio/Pandemic-179-Sonny-2-MP3.mp3")
  ),
  new Dialog(
    "DARETH SCHAMREN: It’s a dog - eat - dog world Sonny Yang. If you’re not willing to do what it takes to survive, then well you’re better off dead.Oh my goodness, I think I feel something coming on…",
    dareth,
    require("@/audio/Pandemic-179-Dareth-2-MP3.mp3")
  ),
  new Dialog(
    "DARETH SCHAMREN: (coughing noises)",
    dareth,
    require("@/audio/Pandemic-179-Dareth-3-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: You, you… did you just COUGH on me! ?",
    yang,

    require("@/audio/Pandemic-179-Sonny-3-MP3.mp3")
  ),
  new Dialog(
    "DARETH SCHAMREN: My apologies Sonny Yang.One of the side effects of having YOGID - 19 is severe respiratory coughing heheheh.",
    dareth,
    require("@/audio/Pandemic-179-Dareth-4-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: … What ?.",
    yang,
    require("@/audio/Pandemic-179-Sonny-4-MP3.mp3")
  ),
  new Dialog(
    "DARETH SCHAMREN: Oh didn’t I tell you ? I tested positive for YOGID just the other day. If you think I’m bluffing you can read the medical reports for yourself Sonny Yang.",
    dareth,
    require("@/audio/Pandemic-179-Dareth-5-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: And yet you waltzed right into the Supermarket, punched me square in the face and have potentially subjected me and dozens of others to infection. You’re sick.",
    yang,
    require("@/audio/Pandemic-179-Sonny-5-MP3.mp3")
  ),
  new Dialog(
    "DARETH SCHAMREN: Tell me something I don’t know brother.Now, as I am a fair man, I would like to offer you a trade. The can of food and toilet paper you’ve swindled for the bottle of sanitiser - bearing in mind the World Health Organisation has recently reported that soap and water alone will not be enough to thwart the virus!",
    require("@/images/dareth.png"),
    require("@/audio/Pandemic-179-Dareth-6-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: Damn you Dareth Schamren.Here, take the food and toilet paper.",
    yang,
    require("@/audio/Pandemic-179-Sonny-6-MP3.mp3")
  ),
  new Dialog(
    "[Lost 1 x Canned Food]",
    canOfFood,
    require("@/audio/loseitem.mp3")
  ),
  new Dialog(
    "[Lost 1 x Toilet Paper]",
    toiletPaper,
    require("@/audio/loseitem.mp3")
  ),
  new Dialog(
    "DARETH SCHAMREN: Much obliged Sonny Yang. As for the sanitizer, I've gone and left it at the place where it all began...",
    dareth,
    require("@/audio/Pandemic-179-Dareth-7-Revised.mp3")
  ),
  new Dialog(
    "SONNY YANG: Schamren!",
    yang,
    require("@/audio/Pandemic-179-Sonny-7-MP3.mp3")
  ),
  new Dialog(
    "DARETH SCHAMREN: Better skedaddle Sonny Yang, time’s a wasting!",
    dareth,
    require("@/audio/Pandemic-179-Dareth-8-MP3.mp3")
  ),
];

export class ConfrontDareth extends Scene {
  async init() {
    this.title = "Dareth's House";
    await this.dialogRunner(confrontation);
    this.state.inventory.beans.has = false;
    this.state.inventory.toiletPaper.has = false;
    this.state.storylines.infectedWithYogid = true;
    await this.navigate(scenes.DarethsHouseExterior());
  }

  get options(): any[] {
    return []
  }
}

export default new ConfrontDareth();
